import React from 'react'

import Checkbox from '../Checkbox'

export const MarketingCheckbox = ({name, className, isChecked, onClick}) => {
  return (
    <Checkbox
      name={name}
      className={className}
      isChecked={isChecked}
      onClick={onClick}
    >
      ฉันต้องการรับโปรโมชันและข่าวสารทางการตลาดเกี่ยวกับ Data Wow
      และบริการอื่น ๆ จากเรา บริษัทในเครือ
      บริษัทย่อยและพันธมิตรทางธุรกิจ &#8203;
      <span style={{whiteSpace: 'nowrap'}}>
        (คุณสามารถยกเลิกได้ทุกเมื่อ)
      </span>
    </Checkbox>
  )
}

export default MarketingCheckbox
